import React from 'react';

function SpotlightRating({ isCompact = false, rating = 'green' }) {
    const ratingClassName = `${rating}-rating`;
    const ratingTitle = rating.charAt(0).toUpperCase() + rating.slice(1);

    let className = `spotlight-rating ${ratingClassName}`;
    if (isCompact) {
        className += ' compact-card';
    }

    return (
        <article className={className}>
            <div className="rating-main">
                <div className="rating-body">
                    <h3 className="rating-title">Spotlight Rating</h3>
                    <p className="rating-level">{ratingTitle}</p>
                </div>
                <div className="rating-graph">
                    <span className="rating-item green"></span>
                    <span className="rating-item yellow"></span>
                    <span className="rating-item red"></span>
                </div>
            </div>
            {!isCompact && (
                <footer className="rating-description">
                    <p className="description-text">FIRE's annual legal analysis of Universities Speech Codes, and a major contributor to a school's overall ranking.</p>
                </footer>
            )}
        </article>
    );
}

export default SpotlightRating;
